import {memo} from "react";
import {HeaderAnpi,Footer} from "../../ui-components";

export const NoneFuncHeaderFooterLayoutAnpi = memo((props)=>{
    const { children } = props;
    return(
        <div style={{backgroundColor:"#F5F5F5", display:"flex",flexDirection:"column",minHeight:"100%", height:"100vh"}}>
            <HeaderAnpi 
                width = "100%"
            />
            {children}
        </div>
    );
});